var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.$store.state.user.customer.manager)?_c('Objects'):(_vm.$store.state.user.id)?_c('Devices'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }